import NhsLogo from './images/logos/nhs.png';
import LabourLogo from './images/logos/labour-party.png';
import AldiLogo from './images/logos/aldi.png';
import MichelinLogo from './images/logos/michelin.png';
import SpecsaversLogo from './images/logos/specsavers.png';
import BrewdogLogo from './images/logos/brewdog.png';
import MitsubishiLogo from './images/logos/mitsubishi.png';
import AgeUKLogo from './images/logos/age-uk.png';
import BSILogo from './images/logos/bsi.png';
import HolidayInnLogo from './images/logos/holiday-inn.png';
import SkanskaLogo from './images/logos/skanska.png';
import BritishExForces from './images/awards/british-ex-forces-entrepreneur-of-the-year.png';
import ExForces from './images/awards/ex-forces-entrepreneur-of-the-year.png';
import ProtectionOfLife from './images/awards/protection-of-life-award-from-geovation.png';
import UKHealthAndSafetyTech from './images/awards/uk-health-and-safety-tech-innovation-2024.png';
import HealthAndSafetyTech from './images/awards/health-and-safety-tech-innovation-2024.png';
import TechNationRisingStars from './images/awards/tech-nation-rising-stars-alumni-2024.png';
import { ResolvedRegion } from '../providers/region-provider/models';

/**
 * The customer logos and award badges, and which of them each region shows.
 *
 * Here rather than beside the components that draw them because two modules
 * draw them: `common` on the marketing panels beside sign-in, and `companies`
 * during onboarding. Sharing the data means a brand added for one appears on
 * the other, and the images have a single owner.
 */

export type BrandLogo = {
    src: string;
    /** The brand's own name — not copy, so it is never translated. */
    brand: string;
};

/** Laid out as rows, because both callers draw them two-per-row. */
export const REGION_BRAND_LOGOS: Record<ResolvedRegion, BrandLogo[][]> = {
    eu: [
        [
            { src: NhsLogo, brand: 'NHS' },
            { src: LabourLogo, brand: 'Labour' }
        ],
        [
            { src: AldiLogo, brand: 'Aldi' },
            { src: MichelinLogo, brand: 'Michelin' }
        ],
        [
            { src: SpecsaversLogo, brand: 'Specsavers' },
            { src: BrewdogLogo, brand: 'Brewdog' }
        ],
        [
            { src: MitsubishiLogo, brand: 'Mitsubishi' },
            { src: AgeUKLogo, brand: 'Age UK' }
        ],
        [
            { src: BSILogo, brand: 'BSI' },
            { src: HolidayInnLogo, brand: 'Holiday Inn' }
        ]
    ],
    us: [
        [
            { src: SkanskaLogo, brand: 'Skanska' },
            { src: MitsubishiLogo, brand: 'Mitsubishi' }
        ],
        [
            { src: AldiLogo, brand: 'Aldi' },
            { src: MichelinLogo, brand: 'Michelin' }
        ],
        [
            { src: SpecsaversLogo, brand: 'Specsavers' },
            { src: BrewdogLogo, brand: 'Brewdog' }
        ]
    ]
};

/**
 * The award badges by name. Callers word their own alt text, because the two
 * that draw these translate it differently.
 */
export const AWARD_IMAGES = {
    britishExForces: BritishExForces,
    exForces: ExForces,
    protectionOfLife: ProtectionOfLife,
    ukHealthAndSafetyTech: UKHealthAndSafetyTech,
    healthAndSafetyTech: HealthAndSafetyTech,
    techNationRisingStars: TechNationRisingStars
} as const;
